import { CustomerCard } from '../customer/customer-card';
import { ProductCard } from '../product/product-card';

export enum PozSubscriptionStatus {
  ACTIVE = 'active',
  PAUSED = 'paused',
  CANCELLED = 'cancelled',
  EXPIRED = 'expired',
}

export enum PozSubscriptionBillingPeriod {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  QUARTERLY = 'quarterly',
  YEARLY = 'yearly',
}

export class PozSubscription {
  id: number;
  customerId: number;
  customerAddressId?: number;
  productId: number;
  price: number;
  quantity: number;
  totalPrice: number;
  billingPeriod: PozSubscriptionBillingPeriod;
  status: PozSubscriptionStatus;
  startDate: Date;
  endDate?: Date;
  nextBillingDate?: Date;
  lastBillingDate?: Date;
  billingCount: number;
  lastOrderDetailId?: number;
  description?: string;
  createdDate: Date;
  updatedDate: Date;

  // Cards loaded dynamically
  customerCard?: CustomerCard;
  productCard?: ProductCard;
}
